import { AxiosInstance } from "axios";

import {
  Assistant,
  AssistantAgentsInput,
  CreateAssistantInput,
  UpdateAssistantInput,
} from "./types";

export const getAssistants = async (
  axiosInstance: AxiosInstance,
  signal?: AbortSignal,
): Promise<Assistant[]> => {
  return (await axiosInstance.get<Assistant[]>(`/assistant/`, { signal }))
    .data;
};

export const getAssistant = async (
  assistantId: string,
  axiosInstance: AxiosInstance,
): Promise<Assistant> => {
  return (await axiosInstance.get<Assistant>(`/assistant/${assistantId}`))
    .data;
};

export const createAssistant = async (
  assistant: CreateAssistantInput,
  axiosInstance: AxiosInstance,
): Promise<Assistant> => {
  return (await axiosInstance.post<Assistant>(`/assistant/`, assistant)).data;
};

export const updateAssistant = async (
  assistantId: string,
  assistant: UpdateAssistantInput,
  axiosInstance: AxiosInstance,
): Promise<Assistant> => {
  return (
    await axiosInstance.put<Assistant>(`/assistant/${assistantId}`, assistant)
  ).data;
};

export const deleteAssistant = async (
  assistantId: string,
  axiosInstance: AxiosInstance,
): Promise<void> => {
  await axiosInstance.delete(`/assistant/${assistantId}`);
};

export const addAssistantAgents = async (
  assistantId: string,
  data: AssistantAgentsInput,
  axiosInstance: AxiosInstance,
): Promise<Assistant> => {
  return (
    await axiosInstance.post<Assistant>(
      `/assistant/${assistantId}/agents`,
      data,
    )
  ).data;
};

export const removeAssistantAgents = async (
  assistantId: string,
  data: AssistantAgentsInput,
  axiosInstance: AxiosInstance,
): Promise<void> => {
  await axiosInstance.delete(`/assistant/${assistantId}/agents`, { data });
};
